export default "ivy-artifact537f2ce5956f4038.svg"